module.exports = __webpack_public_path__ + "static/media/what-to-expect.082a652e.jpg";